// i18n for the R₿L burning system (ES / EN / SK).
export const BURN_I18N = {
  es: {
    title: "R₿L quemados", totalBurned: "Total quemado", thisMonth: "Este mes",
    thisWeek: "Esta semana", percentSupply: "% del supply", recentBurns: "Últimos burns",
    burnedForever: "quemados para siempre", viewTx: "ver TX", burnStats: "Burn Stats",
    paymentSplit: "Distribución del pago", toAcademy: "a RE₿EL Academy",
    toVault: "al Vault pool", burned: "quemados para siempre",
    empty: "Aún no hay burns — cada pago PRO en R₿L quema un 5% automáticamente",
    typePro: "PRO", typeVoluntary: "COMUNIDAD", typeMarket: "MARKET", proBurns: "Burns PRO", voluntaryBurns: "Burns comunidad",
    ago: { m: "hace {n} min", h: "hace {n} h", d: "hace {n} d", now: "ahora" },
  },
  en: {
    title: "R₿L burned", totalBurned: "Total burned", thisMonth: "This month",
    thisWeek: "This week", percentSupply: "% of supply", recentBurns: "Recent burns",
    burnedForever: "burned forever", viewTx: "view TX", burnStats: "Burn Stats",
    paymentSplit: "Payment split", toAcademy: "to RE₿EL Academy",
    toVault: "to Vault pool", burned: "burned forever",
    empty: "No burns yet — every PRO payment in R₿L automatically burns 5%",
    typePro: "PRO", typeVoluntary: "COMMUNITY", typeMarket: "MARKET", proBurns: "PRO burns", voluntaryBurns: "Community burns",
    ago: { m: "{n} min ago", h: "{n}h ago", d: "{n}d ago", now: "now" },
  },
  sk: {
    title: "R₿L spálené", totalBurned: "Celkom spálené", thisMonth: "Tento mesiac",
    thisWeek: "Tento týždeň", percentSupply: "% zásoby", recentBurns: "Posledné spaľovania",
    burnedForever: "spálené navždy", viewTx: "zobraziť TX", burnStats: "Štatistiky spaľovania",
    paymentSplit: "Rozdelenie platby", toAcademy: "do RE₿EL Academy",
    toVault: "do Vault poolu", burned: "spálené navždy",
    empty: "Zatiaľ žiadne spaľovania — každá PRO platba v R₿L automaticky spáli 5 %",
    typePro: "PRO", typeVoluntary: "KOMUNITA", typeMarket: "MARKET", proBurns: "PRO burny", voluntaryBurns: "Komunitné burny",
    ago: { m: "pred {n} min", h: "pred {n} h", d: "pred {n} d", now: "teraz" },
  },
  "zh-CN": {
    title: "R₿L销毁",
    totalBurned: "总销毁量",
    thisMonth: "本月",
    thisWeek: "本周",
    percentSupply: "占总供应量%",
    recentBurns: "最近销毁",
    burnedForever: "永久销毁",
    viewTx: "查看交易",
    burnStats: "销毁统计",
    paymentSplit: "支付分配",
    toAcademy: "给RE₿EL Academy",
    toVault: "给Vault池",
    burned: "永久销毁",
    empty: "暂无销毁记录——每笔R₿L的PRO支付都会自动销毁5%",
    typePro: "PRO",
    typeVoluntary: "社区",
    typeMarket: "市场",
    proBurns: "PRO销毁",
    voluntaryBurns: "社区销毁",
    ago: {
      m: "{n}分钟前",
      h: "{n}小时前",
      d: "{n}天前",
      now: "刚刚",
    },
  },
  de: {
    title: "R₿L verbrannt",
    totalBurned: "Gesamt verbrannt",
    thisMonth: "Diesen Monat",
    thisWeek: "Diese Woche",
    percentSupply: "% des Supplies",
    recentBurns: "Letzte Burns",
    burnedForever: "für immer verbrannt",
    viewTx: "TX anzeigen",
    burnStats: "Burn-Statistiken",
    paymentSplit: "Zahlungsverteilung",
    toAcademy: "an RE₿EL Academy",
    toVault: "an den Vault-Pool",
    burned: "für immer verbrannt",
    empty: "Noch keine Burns — jede PRO-Zahlung in R₿L verbrennt automatisch 5%",
    typePro: "PRO",
    typeVoluntary: "COMMUNITY",
    typeMarket: "MARKET",
    proBurns: "PRO-Burns",
    voluntaryBurns: "Community-Burns",
    ago: {
      m: "vor {n} Min.",
      h: "vor {n} Std.",
      d: "vor {n} T.",
      now: "jetzt",
    },
  },
};

export const tBurn = (lang, key) =>
  (BURN_I18N[lang] || BURN_I18N.es)[key] ?? BURN_I18N.es[key] ?? key;

export const timeAgo = (lang, iso) => {
  const t = (BURN_I18N[lang] || BURN_I18N.es).ago;
  const ms = Date.now() - new Date(iso).getTime();
  const min = Math.floor(ms / 60_000);
  if (min < 1) return t.now;
  if (min < 60) return t.m.replace("{n}", min);
  const h = Math.floor(min / 60);
  if (h < 24) return t.h.replace("{n}", h);
  return t.d.replace("{n}", Math.floor(h / 24));
};
